import { SubviewsRecord } from 'sfportal_components_generic/Subviews'

export function useGetProjectProductTreeDetailSubviews (): () => SubviewsRecord {
  return () => ({})
}
